import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import "./AnimatedFlowTextCh.css";

const AnimatedFlowTextCh = () => {
  // 1. The three words to cycle through:
  const wordList = ["想法", "獨樹一格", "煩惱", "突發奇想", "小圈圈"];

  // 2. State for which word is showing, and fade flags:
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFadingOut, setIsFadingOut] = useState(false);
  const [isFadingIn,  setIsFadingIn]  = useState(false);
  // Ref to always read/write the latest index inside timeouts:
  const indexRef = useRef(0);
  const middleRef = useRef(null);
  const [middleWidth, setMiddleWidth] = useState(0);

  // 3. Timing constants (same as before):
  const OUT_DUR      = 0.5;    // fade-out duration (s)
  const IN_DUR       = 0.4;    // fade-in duration (s)
  const LETTER_DELAY = 0.18;    // stagger (s) only on fade-out
  const PAUSE_MS     = 200;    // pause between out/in (ms)
  const CYCLE_MS     = 3200;   // full cycle period (ms), affects the time the texts stay


  const [slideMargin, setSlideMargin] = useState(14); // start with your gutter

  // whenever the word actually changes...
  useEffect(() => {
    if (!middleRef.current) return;

    // wait until after React has painted the new word
    const handle = window.requestAnimationFrame(() => {
      const w = middleRef.current.offsetWidth;
      setSlideMargin(w + 7);
    });

    return () => window.cancelAnimationFrame(handle);
  }, [currentIndex]);

  const SLIDE_AHEAD_MS  = 500;                     // start slide 150 ms earlier
  const FADE_DELAY_S    = SLIDE_AHEAD_MS / 1000;   // convert to seconds

  useEffect(() => {
    let fadeOutTimeout: ReturnType<typeof setTimeout>;
    let fadeInTimeout: ReturnType<typeof setTimeout>;

    function runCycle() {
      // compute durations based on the current word’s length
      const letters = wordList[indexRef.current].split("");
      const totalFadeOutMs = (OUT_DUR + (letters.length - 1) * (LETTER_DELAY*4.5/(letters.length^(1/2)))) * 1000;
      const totalFadeInMs  = IN_DUR * 1000;

      // 1) start fading out
      setIsFadingOut(true);

      // 2) when fade-out + pause complete → swap word & start fade-in
      fadeOutTimeout = setTimeout(() => {
        setIsFadingOut(false);

        // Step 2.5: Slight pause before word swap (slide will already be happening)
        const next = (indexRef.current + 1) % wordList.length;
        indexRef.current = next;
        setCurrentIndex(next);
        setIsFadingIn(true);

        // stop the flag after fade-in really ends
        const totalIn = SLIDE_AHEAD_MS + IN_DUR * 1000;
        fadeInTimeout = setTimeout(() => setIsFadingIn(false), totalIn);
      }, totalFadeOutMs + PAUSE_MS);
    }

    // kickoff immediately, then every CYCLE_MS
    setTimeout(() => {runCycle()}, 1000);
    const interval = setInterval(runCycle, CYCLE_MS);

    return () => {
      clearInterval(interval);
      clearTimeout(fadeOutTimeout);
      clearTimeout(fadeInTimeout);
    };
  }, []); // run once

  // The letters of whatever word is current
  const letters = wordList[currentIndex].split("");

  
  const innerRef = useRef(null);       // for .flow-wrapper-inner
  const rightRef = useRef(null);       // for .slide-right


  return (
    <div className="flow-wrapper-ch justify-content-start ms-3">
      <div className="flow-wrapper-inner" ref={innerRef}>

        <div className="flow-box-shadow " style={{ marginLeft: "-30px", width: `${120+slideMargin+155}px` }}></div>

        {/* Left: static */}
        <div className="fixed-left">
          {"把你的".split("").map((c,i) => (
            <p key={`ol-${i}`} className="mb-0 outline-text">{c}</p>
          ))}
        </div>

        {/* middle “Ideas” */}
        <div className="middle-word-wrapper" ref={middleRef}>
          <div className="d-flex" style={{ zIndex: "2" }}>
            {letters.map((char, idx) => {
              // decide which animation, and with what delay
              let style = {};
              if (isFadingIn) {
                style = {
                  animationName: "fadeIn",
                  animationDuration: `${IN_DUR}s`,
                  animationDelay:    `${FADE_DELAY_S}s`, // wait while “Matter” slides
                  animationFillMode: "forwards",
                  opacity: 0                         // keep invisible during the delay
                };
              } else if (isFadingOut) {
                style = {
                  animationName: "fadeUpOut",
                  animationDuration: `${OUT_DUR}s`,
                  animationFillMode: "forwards",
                  // reverse stagger: last letter has 0 delay, first has the longest
                  animationDelay: `${(letters.length - 1 - idx) * (LETTER_DELAY*4.5/(letters.length^(1/2)))}s`,
                };
              }
              return (
                <p key={idx} className="mb-0 filled-text" style={style}>
                  {char}
                </p>
              );
            })}
          </div>

          <div
            className="slide-right-gap"
            style={{
              position: "absolute",
              minWidth: "100px",
              minHeight: "45px",
              backgroundColor: "#55b0ff",
              right: `${-100}px`,
              borderTopRightRadius: "10px",
              borderBottomRightRadius: "10px",
              transition: "0.4s ease-in-out",
            }}
          ></div>

          <div
            className="slide-right"
            ref={rightRef}
            style={{
              position: "absolute",
              left: `${Math.max(slideMargin, 67)}px`,
              transition: "0.4s ease-in-out"
            }}
          >
            {"變成價值".split("").map((c,i) => (
              <p key={i} className="mb-0 outline-text">{c}</p>
            ))}
          </div>
        </div>
      </div>

    </div>
  );
};

export default AnimatedFlowTextCh;




